/**
 * 定义三个标准图层的名称，
 * BASELAYER 基本图层即底图
 * FOCUSLAYER 焦点图层即高亮图层
 * EXTRALAYER 额外的图层即动画或其他特殊图层
 */
const BASELAYER = 'baselayer'
const FOCUSLAYER = 'focuslayer'
const EXTRALAYER = 'extralayer'
import axios from 'axios'
/**
 * 编解码器
 */
class codecClass {
    /**
     * 将对象中类型为 string 的变量值进行 encodeURI 编码
     * @param {Object} obj 待编码的对象
     */
    encodeURI(obj) {
        if (obj === null || obj === undefined) return
        Object.keys(obj).forEach(key => {
            let val = obj[key]
            if (typeof val === 'string') obj[key] = encodeURI(val)
        })
    }
    /**
     * 将对象中类型为 string 的变量值进行 encodeURIComponent 编码
     * @param {Object} obj 待编码的对象
     */
    encodeURIComponent(obj) {
        if (obj === null || obj === undefined) return
        Object.keys(obj).forEach(key => {
            let val = obj[key]
            if (typeof val === 'string') obj[key] = encodeURIComponent(val)
        })
    }
    /**
     * 将对象中类型为 string 的变量值进行 encodeURI 解码
     * @param {Object} obj 待编码的对象
     */
    decodeURI(obj) {
        if (obj === null || obj === undefined) return
        Object.keys(obj).forEach(key => {
            let val = obj[key]
            if (typeof val === 'string') obj[key] = decodeURI(val)
        })
    }
    /**
     * 将对象中类型为 string 的变量值进行 decodeURIComponent 解码
     * @param {Object} obj 待编码的对象
     */
    decodeURIComponent(obj) {
        if (obj === null || obj === undefined) return
        Object.keys(obj).forEach(key => {
            let val = obj[key]
            if (typeof val === 'string') obj[key] = decodeURIComponent(val)
        })
    }
    /**
     * 将对象转换为URL string
     * @param {*} obj 
     * @param {*} existingUrl 
     */
    getParamString(obj, existingUrl) {
        var params = [];
        for (var i in obj) {
            params.push(i + '=' + obj[i]);
        }
        return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
    }
}
/**
 * xmlns 生成器
 */
class xmlnsClass {
    _cache = {}
    constructor() {
        this.wfs().fes()
    }
    // xmlns:wfs="http://www.opengis.net/wfs/2.0"
    wfs() {
        this._cache['xmlns:wfs'] = 'http://www.opengis.net/wfs/2.0'
        return this
    }
    // xmlns:fes="http://www.opengis.net/fes/2.0"
    fes() {
        this._cache['xmlns:fes'] = 'http://www.opengis.net/fes/2.0'
        return this
    }
    // xmlns:sf="http://www.openplans.org/spearfish"
    sf() {
        this._cache['xmlns:sf'] = 'http://www.openplans.org/spearfish'
        return this
    }
    // xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
    xsi() {
        this._cache['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance'
        return this
    }
    // xsi:schemaLocation="http://www.opengis.net/wfs/2.0 http://schemas.opengis.net/wfs/2.0/wfs.xsd"
    schemaLocation() {
        this._cache['xsi:schemaLocation'] = 'http://www.opengis.net/wfs/2.0 http://schemas.opengis.net/wfs/2.0/wfs.xsd'
        return this
    }
    a(name, value) {
        if (!name) return
        else if (value === undefined) return this._cache[name]
        else this._cache[name] = value
        return this
    }
    get value() {
        return this._cache
    }
}

/**
 * GEOSERVER 帮助库
 */
class helperClass {
    /**
     * 通过layergroups接口获取图层排序
     * @param {String} service GeoServer服务器地址
     * @param {String} workspace GeoServer工作空间
     * @param {String} group 指定图层组
     */
    async getLayerOrder(service, workspace, group = undefined) {
        if (!service || !workspace) throw 'service和workspace不允许为空'
        var req1 = await axios.get(`${service}/rest/workspaces/${workspace}/layergroups`)
        var groups = req1.data.layerGroups
        if (!groups) throw `${workspace} 不存在图层组信息`
        var req2 = await axios.get(group ? groups.layerGroup.find(p => p.name === group).href : groups.layerGroup[0].href)
        var published = req2.data.layerGroup.publishables.published
        published = Array.isArray(published) ? published : [published]
        return published.map(p => p.name)
    }

    /**
     * 构建临时唯一名称
     * @param {string} prefix 前缀
     */
    _getTempName(prefix) {
        return prefix + new Date().getTime() + parseInt(Math.random() * 10000);
    }

    /**
     * 获取基于SLD的点符号,
     * (2021.04.14)增加变量替换参数testconflict，可控制点符号是否抽稀，默认开启抽稀，抽稀距离为1px，要关闭抽稀效果，传参env=testconflict:false
     * @param {boolean} hasAngle 是否支持旋转(使用字段angle)
     * @param {object} params 配置参数
     * @param {sting|number} [params.size=12] 符号大小，number类型时是像素单位，string类型时，可是m或ft后缀的地理长度单位
     * @param {string} [params.color=#004da8] 符号颜色，16进制颜色字符串
     * @param {string} [params.svghref] 符号使用的外部svg文件链接
     */
    _getPointSymbolizer(zindex, hasAngle, params, nozoom) {
        //默认点符号，可被外部参数覆盖
        let newParams = Object.assign({}, {
            size: 12,
            color: '#004da8'
        }, params);
        //符号是否支持旋转
        let rotation = hasAngle ? '<Rotation><ogc:PropertyName>angle</ogc:PropertyName></Rotation>' : '';
        return `<TextSymbolizer>
                        <Priority>${zindex}</Priority>
                        <Label>
                        <ogc:Function name="if_then_else">
                            <ogc:Function name="env">
                            <ogc:Literal>testconflict</ogc:Literal>
                            <ogc:Literal>true</ogc:Literal>
                            </ogc:Function>
                            ${this._getNozoom(nozoom)}
                            <ogc:Literal></ogc:Literal>
                        </ogc:Function>
                        </Label>
                        <Fill>
                            <CssParameter name="fill-opacity">0.0</CssParameter>
                        </Fill>
                        <VendorOption name="spaceAround">50</VendorOption>
                        <VendorOption name="conflictResolution">true</VendorOption>
                        <LabelPlacement>
                        <PointPlacement>
                            <AnchorPoint>
                            <AnchorPointX>-0.5</AnchorPointX>
                            <AnchorPointY>1</AnchorPointY>
                            </AnchorPoint>
                            <Displacement>
                            <DisplacementX>0</DisplacementX>
                            <DisplacementY>5</DisplacementY>
                            </Displacement>
                            ${rotation}
                        </PointPlacement>
                        </LabelPlacement>
                        <Graphic>
                        ${newParams.svghref ?
                `<ExternalGraphic>
                            <OnlineResource xmlns:xlink="http://www.w3.org/1999/xlink" xlink:type="simple" xlink:href="${newParams.svghref}"/>
                            <Format>image/svg+xml</Format>
                        </ExternalGraphic>`
                : this._getDefaultMark(newParams.color)}
                        <Size>
                            <ogc:Function name="if_then_else">
                            <ogc:Function name="isLike">
                                <ogc:PropertyName>size</ogc:PropertyName>
                                <ogc:Literal>^[0-9]+(\\.[0-9]+)?(m|ft)?$</ogc:Literal>
                            </ogc:Function>
                            <ogc:PropertyName>size</ogc:PropertyName>
                            <ogc:Literal>${newParams.size}</ogc:Literal>
                            </ogc:Function>
                        </Size>
                        </Graphic>
                    </TextSymbolizer>
                    <TextSymbolizer>
                        <Priority>${zindex}</Priority>
                        <Label>
                        <ogc:Function name="if_then_else">
                            <ogc:Function name="env">
                            <ogc:Literal>testconflict</ogc:Literal>
                            <ogc:Literal>true</ogc:Literal>
                            </ogc:Function>
                            <ogc:Literal></ogc:Literal>
                            ${this._getNozoom(nozoom)}
                        </ogc:Function>
                        </Label>
                        <Fill>
                            <CssParameter name="fill-opacity">0.0</CssParameter>
                        </Fill>
                        <VendorOption name="spaceAround">-1</VendorOption>
                        <VendorOption name="conflictResolution">false</VendorOption>
                        <VendorOption name="partials">true</VendorOption>
                        <LabelPlacement>
                        <PointPlacement>
                            <AnchorPoint>
                            <AnchorPointX>0.5</AnchorPointX>
                            <AnchorPointY>0.5</AnchorPointY>
                            </AnchorPoint>
                            <Displacement>
                            <DisplacementX>0</DisplacementX>
                            <DisplacementY>0</DisplacementY>
                            </Displacement>
                            ${rotation}
                        </PointPlacement>
                        </LabelPlacement>
                        <Graphic>
                        ${newParams.svghref ?
                `<ExternalGraphic>
                            <OnlineResource xmlns:xlink="http://www.w3.org/1999/xlink" xlink:type="simple" xlink:href="${newParams.svghref}"/>
                            <Format>image/svg+xml</Format>
                        </ExternalGraphic>`
                : this._getDefaultMark(newParams.color)}
                        <Size>
                            <ogc:Function name="if_then_else">
                            <ogc:Function name="isLike">
                                <ogc:PropertyName>size</ogc:PropertyName>
                                <ogc:Literal>^[0-9]+(\\.[0-9]+)?(m|ft)?$</ogc:Literal>
                            </ogc:Function>
                            <ogc:PropertyName>size</ogc:PropertyName>
                            <ogc:Literal>${newParams.size}</ogc:Literal>
                            </ogc:Function>
                        </Size>
                        </Graphic>
                    </TextSymbolizer>`;
    }

    /**
     * 获取支持nozoom的文本
     * @param {*} nozoom 
     * @returns 
     */
    _getNozoom(nozoom) {
        if (nozoom) {
            return `<ogc:Function name="env">
                        <ogc:Literal>nozoom</ogc:Literal>
                        <ogc:Literal></ogc:Literal>
                    </ogc:Function>`
        } else return '<ogc:Literal>1</ogc:Literal>'
    }

    /**
     * 获取默认mark
     * @param {*} color 
     * @returns 
     */
    _getDefaultMark(color) {
        return `<Mark>
        <WellKnownName>circle</WellKnownName>
        <Fill>
        <CssParameter name="fill">
            <ogc:Function name="env">
            <ogc:Literal>hcolor</ogc:Literal>
            <ogc:Function name="if_then_else">
                <ogc:Function name="isLike">
                <ogc:PropertyName>color</ogc:PropertyName>
                <ogc:Literal>#[0-9a-fA-F][0-9a-fA-F][0-9a-fA-F][0-9a-fA-F][0-9a-fA-F][0-9a-fA-F]</ogc:Literal>
                </ogc:Function>
                <ogc:PropertyName>color</ogc:PropertyName>
                <ogc:Literal>${color}</ogc:Literal>
            </ogc:Function>
            </ogc:Function>
        </CssParameter>
        </Fill>
    </Mark>`
    }

    /**
     * 获取基于SLD的线符号
     * @param {*} params 配置参数
     * @param {sting|number} [params.size=8m] 符号大小，number类型时是像素单位，string类型时，可是m或ft后缀的地理长度单位
     * @param {string} [params.color=#00ca65] 符号颜色，16进制颜色字符串
     */
    _getLineSymbolizer(params) {
        //默认线符号参数，可被外部参数覆盖
        let newParams = Object.assign({}, {
            color: '#00ca65',
            size: '8m'
        }, params);
        return `<LineSymbolizer>
                  <Stroke>
                    <CssParameter name="stroke">
                        <ogc:Function name="env">
                        <ogc:Literal>hcolor</ogc:Literal>
                        <ogc:Function name="if_then_else">
                            <ogc:Function name="isLike">
                            <ogc:PropertyName>color</ogc:PropertyName>
                            <ogc:Literal>#[0-9a-fA-F][0-9a-fA-F][0-9a-fA-F][0-9a-fA-F][0-9a-fA-F][0-9a-fA-F]</ogc:Literal>
                            </ogc:Function>
                            <ogc:PropertyName>color</ogc:PropertyName>
                            <ogc:Literal>${newParams.color}</ogc:Literal>
                        </ogc:Function>
                        </ogc:Function>
                    </CssParameter>
                    <CssParameter name="stroke-linecap">round</CssParameter>
                    <CssParameter name="stroke-linejoin">round</CssParameter>
                    <CssParameter name="stroke-width">
                      <ogc:Function name="if_then_else">
                        <ogc:Function name="isLike">
                          <ogc:PropertyName>size</ogc:PropertyName>
                          <ogc:Literal>^[0-9]+(\\.[0-9]+)?(m|ft)?$</ogc:Literal>
                        </ogc:Function>
                        <ogc:PropertyName>size</ogc:PropertyName>
                        <ogc:Literal>${newParams.size}</ogc:Literal>
                      </ogc:Function>
                    </CssParameter>
                  </Stroke>
                </LineSymbolizer>`
    }
}



//定义一些常量
const x_PI = (3.14159265358979324 * 3000.0) / 180.0
const PI = 3.1415926535897932384626
const a = 6378245.0
const ee = 0.00669342162296594323

/**
* Created by Wandergis on 2015/7/8.
* 提供了百度坐标（BD09）、国测局坐标（火星坐标，GCJ02）、和WGS84坐标系之间的转换
*/
class transformClass {

    /**
     * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
     * 即 百度 转 谷歌、高德
     * @param bd_lon
     * @param bd_lat
     * @returns {*[]}
     */
    bd09togcj02(bd_lon, bd_lat) {
        var x_pi = (3.14159265358979324 * 3000.0) / 180.0
        var x = bd_lon - 0.0065
        var y = bd_lat - 0.006
        var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
        var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
        var gg_lng = z * Math.cos(theta)
        var gg_lat = z * Math.sin(theta)
        return [gg_lng, gg_lat]
    }

    /**
     * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
     * 即谷歌、高德 转 百度
     * @param lng
     * @param lat
     * @returns {*[]}
     */
    gcj02tobd09(lng, lat) {
        var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI)
        var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI)
        var bd_lng = z * Math.cos(theta) + 0.0065
        var bd_lat = z * Math.sin(theta) + 0.006
        return [bd_lng, bd_lat]
    }

    /**
     * WGS84转GCj02
     * @param lng
     * @param lat
     * @returns {*[]}
     */
    wgs84togcj02(lng, lat) {
        if (this.out_of_china(lng, lat)) {
            return [lng, lat]
        } else {
            var dlat = this.transformlat(lng - 105.0, lat - 35.0)
            var dlng = this.transformlng(lng - 105.0, lat - 35.0)
            var radlat = (lat / 180.0) * PI
            var magic = Math.sin(radlat)
            magic = 1 - ee * magic * magic
            var sqrtmagic = Math.sqrt(magic)
            dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI)
            dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI)
            var mglat = lat + dlat
            var mglng = lng + dlng
            return [mglng, mglat]
        }
    }

    /**
     * GCJ02 转换为 WGS84
     * @param lng
     * @param lat
     * @returns {*[]}
     */
    gcj02towgs84(lng, lat) {
        if (this.out_of_china(lng, lat)) {
            return [lng, lat]
        } else {
            var dlat = this.transformlat(lng - 105.0, lat - 35.0)
            var dlng = this.transformlng(lng - 105.0, lat - 35.0)
            var radlat = (lat / 180.0) * PI
            var magic = Math.sin(radlat)
            magic = 1 - ee * magic * magic
            var sqrtmagic = Math.sqrt(magic)
            dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI)
            dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI)
            var mglat = lat + dlat
            var mglng = lng + dlng
            return [lng * 2 - mglng, lat * 2 - mglat]
        }
    }

    transformlat(lng, lat) {
        var ret =
            -100.0 +
            2.0 * lng +
            3.0 * lat +
            0.2 * lat * lat +
            0.1 * lng * lat +
            0.2 * Math.sqrt(Math.abs(lng))
        ret +=
            ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) *
                2.0) /
            3.0
        ret +=
            ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) /
            3.0
        ret +=
            ((160.0 * Math.sin((lat / 12.0) * PI) +
                320 * Math.sin((lat * PI) / 30.0)) *
                2.0) /
            3.0
        return ret
    }

    transformlng(lng, lat) {
        var ret =
            300.0 +
            lng +
            2.0 * lat +
            0.1 * lng * lng +
            0.1 * lng * lat +
            0.1 * Math.sqrt(Math.abs(lng))
        ret +=
            ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) *
                2.0) /
            3.0
        ret +=
            ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) /
            3.0
        ret +=
            ((150.0 * Math.sin((lng / 12.0) * PI) +
                300.0 * Math.sin((lng / 30.0) * PI)) *
                2.0) /
            3.0
        return ret
    }

    /**
     * 判断是否在国内，不在国内则不做偏移
     * @param lng
     * @param lat
     * @returns {boolean}
     */
    out_of_china(lng, lat) {
        return (
            lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271 || false
        )
    }
}
const codec = new codecClass()
const xmlns = new xmlnsClass()
const helper = new helperClass()
const transform = new transformClass()
export {
    BASELAYER,
    FOCUSLAYER,
    EXTRALAYER,
    codec,
    xmlns,
    helper,
    transform
}